import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useSplashStore = defineStore('splash', () => {
  // State
  const isVisible = ref(false);
  const message = ref('você será redirecionado em instantes...');
  const duration = ref(3000);
  const redirectCallback = ref<(() => void) | null>(null);

  // Getters
  const isShowing = computed(() => isVisible.value);

  // Actions
  function showSplash(customMessage?: string, customDuration?: number, onComplete?: () => void) {
    isVisible.value = true;

    if (customMessage) {
      message.value = customMessage;
    }

    if (customDuration) {
      duration.value = customDuration;
    }

    if (onComplete) {
      redirectCallback.value = onComplete;
    }

    // Auto-hide splash após a duração especificada
    setTimeout(() => {
      hideSplash();
    }, duration.value);
  }

  function hideSplash() {
    isVisible.value = false;

    // Execute callback se existir
    if (redirectCallback.value) {
      redirectCallback.value();
      redirectCallback.value = null;
    }
  }

  function setSplashMessage(newMessage: string) {
    message.value = newMessage;
  }

  function reset() {
    isVisible.value = false;
    message.value = 'você será redirecionado em instantes...';
    duration.value = 3000;
    redirectCallback.value = null;
  }

  return {
    // State (readonly for external access)
    isVisible: readonly(isVisible),
    message: readonly(message),
    duration: readonly(duration),

    // Getters
    isShowing,

    // Actions
    showSplash,
    hideSplash,
    setSplashMessage,
    reset,
  };
});
